import * as React from "react"

const DefaultStrideIcon = (props) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5 1.5h-6a.75.75 0 0 0-.651.378l-6 10.497-.055.117a.75.75 0 0 0 .706 1.005h7.123l-3.315 7.959c-.332.796.722 1.43 1.27.765l10.5-12.746.072-.101a.75.75 0 0 0-.65-1.126h-5.477l3.132-5.634A.75.75 0 0 0 17.5 1.5ZM16.223 3l-3.129 5.634-.053.117a.75.75 0 0 0 .709.997h5.16l-6.272 7.615 1.804-4.328.04-.124a.75.75 0 0 0-.732-.914H6.79L11.935 3h4.288Z"
      fill="#80B8EE"
    />
  </svg>
)

export default DefaultStrideIcon;